import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useBnsXiangMuUpdateQuery } from '../store/BnsKeJiApi'
import { Button, Divider, Flex } from 'antd'
import WebMain from './WebMain'
import { h5SketchClient } from './h5Routes'

function FrontSketchProject() {
    const [param] = useSearchParams()
    const navigate = useNavigate()
    const bxm_id = param.get('bxm_id')
    const { data, isSuccess } = useBnsXiangMuUpdateQuery({ bxm_id }, { skip: !bxm_id })
    const [info, setInfo] = useState({
        bxm_content: '',
        children: [],
    })
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const sorrArr = [...(data.Result.children || [])].sort((a, b) => {
                    const getFirstNumber = (name) => {
                        const match = name.match(/\d+/)
                        return match ? parseInt(match[0], 10) : 0
                    }
                    return getFirstNumber(a.yh_name) - getFirstNumber(b.yh_name)
                })
                setInfo({
                    bxm_content: data.Result.bxm_content,
                    bxm_name: data.Result.bxm_name,
                    bxm_dept_id: data.Result.bxm_dept_id,
                    bxm_dept_name: data.Result.bxm_dept_name,
                    bxm_ctime: data.Result.bxm_ctime,
                    bxm_cname: data.Result.bxm_cname,
                    bxm_num: data.Result.bxm_num,
                    children: sorrArr,
                })
            }
        }
    }, [data, isSuccess])

    return (
        <WebMain>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch', padding: '0 12px 24px' }}>
                <h1 style={{ textAlign: 'center', color: '#fff', fontSize: 20, marginTop: 8 }}>{info.bxm_name}</h1>
                <Divider style={{ color: '#fff', margin: '12px 0' }}>项目说明</Divider>
                <div
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        backgroundColor: '#fff',
                        padding: 12,
                        borderRadius: 8,
                    }}
                    dangerouslySetInnerHTML={{ __html: info.bxm_content }}
                />
                <Divider style={{ color: '#fff', margin: '12px 0' }}>客户端</Divider>
                <div style={{ width: '100%' }}>
                    {info.children &&
                        Array.isArray(info.children) &&
                        info.children.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundColor: '#fff',
                                    padding: 12,
                                    borderRadius: 8,
                                    marginBottom: 10,
                                    border: '1px solid #f0f0f0',
                                }}
                            >
                                <Flex vertical gap={12}>
                                    <Flex gap={12} align="flex-start">
                                        <img
                                            src={`/api/assets/images/application/${item.yh_image}`}
                                            alt=""
                                            style={{ width: 72, height: 72, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }}
                                            onError={(e) => {
                                                e.target.src = '/img/home/logo.png'
                                            }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ marginBottom: 8 }}>
                                                <span style={{ fontSize: 17, fontWeight: 'bold' }}>{item.yh_name}</span>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: item.yh_content }} style={{ color: '#666', lineHeight: 1.6, fontSize: 14 }} />
                                        </div>
                                    </Flex>
                                    <Button
                                        type="primary"
                                        block
                                        onClick={() => {
                                            navigate(
                                                h5SketchClient({
                                                    yh_id: item.yh_id,
                                                    yh_name: item.yh_name,
                                                    bxm_id,
                                                    bxm_name: info.bxm_name,
                                                })
                                            )
                                        }}
                                    >
                                        查看详情
                                    </Button>
                                </Flex>
                            </div>
                        ))}
                </div>
            </div>
        </WebMain>
    )
}

export default FrontSketchProject
